import { SxProps, Theme } from "@mui/material";

export const homeScreenStyles = {
  container: (theme: Theme): SxProps<Theme> => ({
    margin: "1rem 1.5rem",
    [theme.breakpoints.down(400)]: {
      margin: "1rem",
    },
  }),
  categoriesContainer: {
    // margin: "1rem",
  },
  bookableContainer: {
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  marginTop: 2,

  "& > *": {
    flexBasis: {
      xs: "100%",
      sm: "40%",
      md: "24%",
    },
    maxWidth: {
      xs: "100%",
      sm: "40%",
      md: "24%",
    },
    flexGrow: 0,
    flexShrink: 0,
  },
},

  subCardsContainer: (theme: Theme): SxProps<Theme> => ({
    flexWrap: "wrap",

    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },


  }),
  toggleButtonsContainer: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "center",
    padding: 0,
    mb: "1.3rem",
    mt: "1rem",
    gap: "2rem",
    [theme.breakpoints.down(400)]: {
      gap: "1rem",
    },
  }
  ),
  datePickerContainer: {
    width: "fit-content",
    alignSelf: "flex-start",
    pt: { 
      xs: 2, 
      md: 4 
    },
  },
  bookableItemsCount: {
    mt: "8px",
    // paddingLeft: { xs: "10px", sm: "25px" },
  },
  cardsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "1.25rem",
  },
  calenderEndorcementBox: { cursor: "pointer", display: "flex" },
  calenderStyles: (theme: Theme) => ({
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    lineHeight: "26px",
    letterSpacing: "0.074px",
    borderBottom: "0.5px solid black",
    maxWidth: "240px",
  }),
  inputProps: {
    fontWeight: "bold",
    width: "fit-content",
  },
};
